// Components which serve as wrappers as part of a parent router
import { userSelector } from "@redux/user"
import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import DisableRoleSelect from "@components/Navigation/DisableRoleSelect"
import { useHasAccessToFFAClubSupport, useIsWellbeingOperational } from "@utils/customization/customization"
import { lazy, type PropsWithChildren } from "react"
import { Navigate } from "react-router-dom"
import { lazyRetry } from "./utils"
export const UnauthenticatedLayout = lazy(() => lazyRetry(() => import("../layouts/UnauthenticatedLayout"), "unauthenticatedLayout"))
export const AuthenticatedLayout = lazy(() => lazyRetry(() => import("../layouts/AuthenticatedLayout"), "authenticatedLayout"))
export const AdminOnlyRoute = ({ children }: PropsWithChildren) => {
	const { t } = useTranslation()
	const { isPlainAdmin, isAdmin } = useSelector(userSelector)
	if (isPlainAdmin) {
		return (
			<>
				<DisableRoleSelect />
				{children}
			</>
		)
	} else {
		if (isAdmin) {
			toast.error(t("Sinut ohjattiin etusivulle, koska tämä sivu ei ole käytettävissä roolivalinnan ollessa päällä."))
		}
		return <Navigate to={"/"} />
	}
}

// User must be in the wellbeing operational class
export const WellbeingWrapper = ({ children }: PropsWithChildren) => {
	const { isPlainAdmin } = useSelector(userSelector)
	const isWellbeing = useIsWellbeingOperational()

	if (isWellbeing || isPlainAdmin) {
		return <>{children}</>
	} else {
		return null
	}
}

// User must be a coach and have a valid bucket level
export const FFAClubSupportWrapper = ({ children }: PropsWithChildren) => {
	const hasAccess = useHasAccessToFFAClubSupport()

	if (!hasAccess) {
		return null
	}

	return <>{children}</>
}
